import {
  ArchitectureModule,
  createArchitectureServices
} from "./chunk-6AZGARVD.mjs";
import "./chunk-FOHPRMQF.mjs";
export {
  ArchitectureModule,
  createArchitectureServices
};
